/**
 * Weglot integration with custom language switcher
 * This script connects our custom language switcher to Weglot's functionality
 */

// Function to initialize custom language switcher with Weglot integration
const initWeglotCustom = function () {
  // Wait for Weglot to be fully loaded
  const checkWeglotLoaded = setInterval(() => {
    // Check for the Weglot language switcher
    const weglotSwitcher = document.getElementById("weglot-language-switcher");

    if (weglotSwitcher) {
      clearInterval(checkWeglotLoaded);

      // Initialize the dropdown functionality
      initDropdown(weglotSwitcher);
    }
  }, 300);
};

// Function to initialize dropdown functionality
const initDropdown = function (switcher) {
  if (!switcher) return;

  // Get the button and list
  const button = switcher.querySelector(".language-switcher__title");
  const list = switcher.querySelector(".language-switcher__list");

  if (!button || !list) return;

  // Toggle dropdown on button click
  button.addEventListener("click", function (e) {
    e.preventDefault();
    switcher.classList.toggle("active");
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", function (e) {
    if (!switcher.contains(e.target)) {
      switcher.classList.remove("active");
    }
  });
};

// No need for additional functions as the language switching is now handled
// directly by the PHP code in language_switcher.php through the onclick attribute
// that redirects to the appropriate URL for each language

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", initWeglotCustom);

// Also initialize when window loads (as a fallback)
window.addEventListener("load", initWeglotCustom);

// Export the initialization function
export { initWeglotCustom };
